import { Action } from 'redux';

import { ReorderItem } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { SpaceInfo } from '../state/SpaceInfo';

export interface ReorderItemAction extends Action {
  fromIndex: number;
  indexToMoveAfter: number;
  spaceInfo: SpaceInfo;
}

export function reorderItem(fromIndex: number, indexToMoveAfter: number, spaceInfo: SpaceInfo): ReorderItemAction {
  return {
    type: ReorderItem,
    spaceInfo,
    fromIndex,
    indexToMoveAfter: indexToMoveAfter,
  };
}

export const isReorderItemAction = isActionFactory<ReorderItemAction>(ReorderItem);
